import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  menuButton: {
    borderRadius: "20px",
    width: "100%",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: "auto",
  },
  drawerItem: {
    marginBottom: theme.spacing(1),
    borderRadius: "20px",
    color: "white",
    backgroundColor: "#1C224C",
    "&:hover": {
      backgroundColor: "#343A5F",
    },
  },
  drawerSelectedItem: {
    marginBottom: theme.spacing(1),
    borderRadius: "20px",
    color: "white",
    backgroundColor: "#a7d2a9",
    "&:hover": {
      backgroundColor: "#84A085",
    },
  },
}));

export default function SideDrawer(props) {
  const navigate = useNavigate();

  const handleGoToPage = (page) => {
    if (props.onClose) props.onClose();
    console.log(page);
    if (page === "Dashboard") {
      setButtonActive("Dashboard");
      navigate("/homeAdmin/dashboard");
    }
    if (page === "Cobranza") {
      setButtonActive("Cobranza");
      navigate("/homeAdmin/cobranza");
    }
    if (page === "Gestión Cartera") {
      setButtonActive("Gestión Cartera");
      navigate("/homeAdmin/gestion-cartera");
    }
    if (page === "Chat cobranza") {
      setButtonActive("Chat cobranza");
      navigate("/homeAdmin/chat-cobranza");
    }
    if (page === "Comercios") {
      setButtonActive("Comercios");
      navigate("/homeAdmin/comercios");
    }
    if (page === "Parametros") {
      setButtonActive("Parametros");
      navigate("/homeAdmin/modify-parameters");
    }
    if (page === "Reportes") {
      setButtonActive("Reportes");
      navigate("/homeAdmin/reportes");
    }
    if (page === "Validación informes") {
      setButtonActive("Validación informes");
      navigate("/homeAdmin/validacion-informes");
    }
    if (page === "Clientes") {
      setButtonActive("Clientes");
      navigate("/homeAdmin/clientes");
    }
    if (page === "Fondeadores") {
      setButtonActive("Fondeadores");
      navigate("/homeAdmin/fondeadores");
    }
    if (page === "Gestión Manual") {
      setButtonActive("Gestión Manual");
      navigate("/homeAdmin/gestion-manual");
    }
    if (page === "Solicitudes") {
      setButtonActive("Solicitudes");
      navigate("/homeAdmin/solicitudes");
    }
    if (page === "Politicas") {
      setButtonActive("Politicas");
      navigate("/homeAdmin/politicas");
    }
    if (page === "Asignaciones") {
      setButtonActive("Asignaciones");
      navigate("/homeAdmin/asignaciones");
    }
    if (page === "Novedades siigo") {
      setButtonActive("Novedades siigo");
      navigate("/homeAdmin/novedades-siigo");
    }
    if (page === "Flujos WhatsApp") {
      setButtonActive("Flujos WhatsApp");
      navigate("/homeAdmin/flujos-whatsapp");
    }
    if (page === "Scores") {
      setButtonActive("Scores");
      navigate("/homeAdmin/scores");
    }
    if (page === "Campanas") {
      setButtonActive(page);
      navigate("/homeAdmin/campanas");
    }
    if (page === "Expedición certificados") {
      setButtonActive("Expedición certificados");
      navigate("/homeAdmin/expedicion-certificados");
    }
    if (page === "Contabilidad Siigo") {
      setButtonActive("Contabilidad Siigo");
      navigate("/homeAdmin/contabilidad-siigo");
    }
    if (page === "Condonaciones") {
      setButtonActive("Condonaciones");
      navigate("/homeAdmin/condonaciones");
    }
  };

  const classes = useStyles();

  const drawerWidth = 240;

  const menuItems = [
    "Dashboard",
    "Solicitudes",
    "Cobranza",
    "Chat cobranza",
    "Comercios",
    "Clientes",
    "Fondeadores",
    "Parametros",
    "Reportes",
    "Gestión Manual",
    "Novedades eliminacion cuota",
  ];
  const permits = JSON.parse(localStorage.getItem("permits")).items;

  const [buttonAcitve, setButtonActive] = useState(permits[0]);

  console.log("sideDrawer");

  const temporary = Boolean(props.temporary);

  return (
    <Box sx={{ flexShrink: 0, width: temporary ? 0 : drawerWidth }}>
      <Drawer
        variant={temporary ? "temporary" : "permanent"}
        open={temporary ? Boolean(props.open) : true}
        onClose={props.onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          width: temporary ? 0 : drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <br />
        <br />
        <Box sx={{ overflow: "auto" }} mt={"4vh"}>
          <List className={classes.drawerContainer}>
            {permits.map((text, index) => {
              if (text == buttonAcitve) {
                return (
                  <Button
                    className={classes.menuButton}
                    key={text}
                    onClick={() => handleGoToPage(text)}
                  >
                    <ListItem className={classes.drawerSelectedItem} key={text}>
                      {" "}
                      {text}{" "}
                    </ListItem>
                  </Button>
                );
              } else {
                return (
                  <Button
                    className={classes.menuButton}
                    key={text}
                    onClick={() => handleGoToPage(text)}
                  >
                    <ListItem className={classes.drawerItem} key={text}>
                      {text}{" "}
                    </ListItem>
                  </Button>
                );
              }
            })}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}
